export enum Path {
  Blank = '',
  Root = '/',
  WildCard = '**',
  Home = 'home',
  NewReservation = 'new-reservation',
  Reservations = 'reservations',
  Warehouse = 'warehouse',
  GpsLink = 'gps-link',
  AllReservations = 'all-reservations',
  AllWarehouses = 'warehouses',
  SunbedsLanding = 'sunbeds',
  ZoneSelection = 'zones',
  SunbedSelection = 'sunbed-selection',
  SunbedCart = 'sunbed-cart',
  DailyReports = 'daily-reports',
}
